function Card({ children, className = '', ...props }) {
  return (
    <div
      className={`bg-card rounded-2xl shadow-sm border border-divider p-5 ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
